import axiosInstance from './api';
import { urlBase64ToUint8Array } from '../send-sw-details';

const VAPID_PUBLIC_KEY = "BKvNbHgS5v8Zte52gho8pFEOgS0gG65hl6rCYaJhEd7ewl27DNzRFNn-M69H8Gw9dyVKK_bu9Q9TAe16Onl0nkA"; // Replace with your actual VAPID public key

// Add service worker registration function
export const registerServiceWorker = async () => {
  try {
    if ("serviceWorker" in navigator) {
      const registration = await navigator.serviceWorker.register("./sw.js");
      console.log("Service Worker registered successfully", registration);
      return registration;
    }
    return null;
  } catch (error) {
    console.error("Service Worker registration failed:", error);
    return null;
  }
};

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      return true;
    }
    return false;
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return false;
  }
};

export const subscribeToPushNotifications = async (userId) => {
  try {
    console.log("Starting push notification subscription process...");
    
    // Check if notifications are supported
    if (!("Notification" in window)) {
      console.error("This browser does not support notifications");
      return { success: false };
    }
    
    // Check if service workers are supported
    if (!("serviceWorker" in navigator)) {
      console.error("This browser does not support service workers");
      return { success: false };
    }
    
    // Ensure permission is granted
    if (Notification.permission !== 'granted') {
      console.log("Requesting notification permission...");
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        console.error("Notification permission denied");
        return { success: false };
      }
    }
    
    // First ensure service worker is registered
    console.log("Waiting for service worker to be ready...");
    let registration = await navigator.serviceWorker.ready;
    if (!registration) {
      console.log("Service worker not ready, attempting to register...");
      registration = await registerServiceWorker();
      if (!registration) {
        throw new Error('Service Worker registration failed');
      }
    }
    
    // Check for existing subscription to avoid duplicates
    console.log("Checking for existing subscription...");
    const existingSubscription = await registration.pushManager.getSubscription();
    if (existingSubscription) {
      console.log("Existing subscription found:", existingSubscription);
      // Still send to server in case it wasn't saved before
      await axiosInstance.post('/push-notification/subscription', {
        userId,
        subscription: existingSubscription
      });
      return { success: true, isNew: false };
    }
    
    console.log("Creating new push subscription...");
    const push = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
    });
    
    console.log("Subscription created:", push);
    console.log("Sending subscription to server...");
    
    const response = await axiosInstance.post('/push-notification/subscription', {
      userId,
      subscription: push
    });
    
    console.log("Server response:", response.data);
    return { success: true, isNew: true };
  } catch (error) {
    console.error('Error subscribing to push notifications:', error);
    // Log additional details that might help diagnose the issue
    if (error.name === 'NotAllowedError') {
      console.error('Permission denied for push notifications');
    } else if (error.name === 'AbortError') {
      console.error('Push subscription aborted');
    } else if (error.response) {
      console.error('Server response error:', error.response.data);
    }
    return { success: false };
  }
};

export const unsubscribeFromPushNotifications = async (userId) => {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    
    if (subscription) {
      await subscription.unsubscribe();
      
      await axiosInstance.post('/push-notification/unsubscription', {
        userId
      });
    }
    
    return true;
  } catch (error) {
    console.error('Error unsubscribing from push notifications:', error);
    return false;
  }
};